import React, { useRef, useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { Mensaje, MensajeSiNo } from "./mensajes";
import { Dimmer } from "./spinner";
import moment, { min } from "moment";
import {
  formatMoneda,
  validaMonto,
  formatoMonto,
  seleccionarCampo,
} from "../util/varios";
import axios from "axios";

export const AgregarPago = (props) => {
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [activate, setActivate] = useState(false);
  const [deshabilitado, setDeshabilitado] = useState(false);
  const [operacion, setOperacion] = useState(0);
  const [fechaSistema, setFechaSistema] = useState(
    localStorage.getItem("fechasistema")
  );
  const [values, setValues] = useState();
  const txtMonto = useRef();
  const txtReferencia = useRef();
  const btnCancela = useRef();
  const btnAcepta = useRef();
  const cmbBancoCli = useRef();
  const cmbFormaPago = useRef();
  const cmbCuenta = useRef();
  const txtFechaDoc = useRef();
  const [cuentas, setCuentas] = useState([]);
  const [bancos, setBancos] = useState([]);
  const [cuentasBanca, setCuentasBanca] = useState("0");
  const [bancoCli, setBancoCli] = useState("0");
  const [datos, setDatos] = useState([]);

  const op = require("../../public/modulos/datos");
  const token = JSON.parse(localStorage.getItem("jwtToken"));

  const allBancos = () => {
    let endpoint = `${op.conexion}/api/comun/seleccionaregistros?campos=*&nomtab=bancos&orden=idbanco`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setBancos(response.data);
        }
      })
      .catch(function (error) {
        // setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
      });
  };

  const allCuentabancarias = () => {
    let endpoint = `${op.conexion}/api/comun/seleccionaregistros?campos=idcuentabancaria,nombre,cuentabancaria&nomtab=cuentabancaria&orden=idcuentabancaria`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setCuentas(response.data);
        }
      })
      .catch(function (error) {
        // setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
      });
  };

  const onChangeValidar = (e) => {
    e.preventDefault();
    var sigue = true;

    if (txtFechaDoc.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe Seleccionar la Fecha del Documento",
        icono: "informacion",
      });
      sigue = false;
      txtFechaDoc.current.focus();
    } else if (cmbFormaPago.current.value.trim() === "0") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe Seleccionar la Forma de Pago",
        icono: "informacion",
      });
      sigue = false;
      cmbFormaPago.current.focus();
    } else if (cmbBancoCli.current.value.trim() === "0") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe Seleccionar el Banco",
        icono: "informacion",
      });
      sigue = false;
      cmbBancoCli.current.focus();
    } else if (txtReferencia.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe Introducir el Número del Documento",
        icono: "informacion",
      });
      sigue = false;
      txtReferencia.current.focus();
    } else if (
      txtMonto.current.value.trim() === "" ||
      txtMonto.current.value.trim() === "0,00"
    ) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Introduzca el Monto",
        icono: "informacion",
      });
      sigue = false;
      txtMonto.current.focus();
    } else if (cmbCuenta.current.value.trim() === "0") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe Seleccionar la Cuenta Bancaria",
        icono: "informacion",
      });
      sigue = false;
      cmbCuenta.current.focus();
    } else if (sigue) {
      var data = [];
      data.push({
        fechadoc: txtFechaDoc.current.value,
        numdocumento: txtReferencia.current.value,
        monto: txtMonto.current.value,
        idtipopago: cmbFormaPago.current.value,
        destipopago:
          cmbFormaPago.current[cmbFormaPago.current.selectedIndex].text,
        idbanco: cmbBancoCli.current.value,
        nombanco: cmbBancoCli.current[cmbBancoCli.current.selectedIndex].text,
        idcuentabancaria: cmbCuenta.current.value,
        cuentabanco: cmbCuenta.current[cmbCuenta.current.selectedIndex].text,
      });

      setDatos(data);

      let msg = "";
      if (props.operacion === 1) {
        msg = "El registro fue Ingresado.";
      } else if (props.operacion === 2) {
        msg = "El registro fue Modificado.";
      } else if (props.operacion === 3) {
        msg = "Esta Seguro de Eliminar estos Datos?.";
      }

      //props.onHideAcepta(datos);
      //setMensajesino({ mostrar: true, titulo: 'Confirmación', texto: msg, icono: 'confirmacion' });
      setMensaje({
        mostrar: true,
        titulo: "Exito.",
        texto: msg,
        icono: "exito",
      });
    }
  };

  const Actualizar = (operacion) => {
    let endpoint = `${op.conexion}/api/retencion/actualizarretenciontemp/${props.operacion}`;
    let body;
    setActivate(true);

    body = {
      //idretentemp: parseInt(txtIdReten.current.value),
      txtagente: props.agente,
      txtfechac: txtFechaDoc.current.value,
      //txttipo: txtTipo.current.value.trim(),
      //txtcontrol: txtNintru.current.value.trim(),
      //txtbanco: txtBanco.current.value.trim(),
      //txtreferencia: txtReferencia.current.value.trim(),
      txtbanco: "null",
      txtreferencia: "null",
      //txtrif: txtCedularif.current.value,
      //txtrazon: txtNombres.current.value.trim(),
      //txtmontob: parseFloat(txtMontobruto.current.value.trim().replace(/\./g, '').replace(',', '.')),
      txtperiodo: props.periodo.padStart(7, "0"),
      txtretenido: parseFloat(
        txtMonto.current.value.trim().replace(/\./g, "").replace(",", ".")
      ),
    };

    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (props.operacion === 1) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro creado correctamente",
              icono: "exito",
            });
          } else if (props.operacion === 2) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro modificado correctamente",
              icono: "exito",
            });
          } else if (props.operacion === 3) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro eliminado correctamente",
              icono: "exito",
            });
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const handleInputMontoChange = (event) => {
    validaMonto(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (
        event.target.value === "" ||
        parseFloat(
          event.target.value.trim().replace(".", "").replace(",", ".")
        ) === 0.0
      ) {
        event.target.value = "0,00";
      }
      event.target.value = formatoMonto(event.target.value);
      let char1 = event.target.value.substring(0, 1);
      let char2 = event.target.value.substring(1, 2);
      if (char1 === "0" && char2 !== ",") {
        event.target.value = event.target.value.substring(
          1,
          event.target.value.legth
        );
      }

      if (event.target.id === "inputMonto") {
        let porpag = parseFloat(props.porpagar);
        porpag = Math.round(porpag * Math.pow(10, 2)) / Math.pow(10, 2);
        let mon = parseFloat(
          event.target.value.replace(/\./g, "").replace(",", ".")
        );
        mon = Math.round(mon * Math.pow(10, 2)) / Math.pow(10, 2);
        if (mon > porpag) {
          event.target.value = formatMoneda(
            props.porpagar.toString().replace(",", "").replace(".", ","),
            ",",
            ".",
            2
          );
          txtMonto.current.focus();
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "El Monto Pagado es Mayor al Monto Total de la Factura.",
            icono: "informacion",
          });
        } else {
          if (event.which === 13) {
            cmbCuenta.current.focus();
          }
        }
      }
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };

  const handleCloseSi = () => {
    //Actualizar();
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
  };

  const cerrarModal = () => {
    props.onHideAcepta(datos);
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
  };

  const cancelar = () => {
    props.onHideCancela();
  };

  useEffect(() => {
    allBancos();
    allCuentabancarias();
  }, [props.porpagar]);

  const handleChangeCuentaBan = (event) => {
    setCuentasBanca(event.target.value);
    if (event.target.value === "0") {
      return;
    }
  };

  const handleChangeBancoCli = (event) => {
    setBancoCli(event.target.value);
    if (event.target.value === "0") {
      return;
    }
  };

  const handleInputChange = (event) => {
    if (event.which === 13) {
      var valido;
      if (event.target.id === "fechaDoc") {
        cmbFormaPago.current.focus();
      }
    } else if (typeof event.which === "undefined") {
      return false;
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
      backdrop="static"
      keyboard={false}
      onShow={() => {
        //btnAcepta.current.focus();
        setOperacion(props.operacion);
        if (props.operacion !== 1) {
        }
        txtMonto.current.value = formatMoneda(
          props.porpagar.toString().replace(",", "").replace(".", ","),
          ",",
          ".",
          2
        );
        txtFechaDoc.current.focus();
      }}
    >
      <Modal.Header className="azulGradiant2 header-modal">
        <div className="fw-bold text-light">
          <h3>
            {props.operacion === 1
              ? "Incluir Forma de Pago."
              : props.operacion === 2
              ? "Editar Forma de Pago."
              : props.operacion === 3
              ? "Eliminar Forma de Pago."
              : "Consultar Forma de Pago."}
          </h3>
        </div>
        <button
          ref={btnCancela}
          className="btn"
          style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }}
          onClick={cancelar}
        >
          <i className="far fa-window-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body className="" style={{ backgroundColor: "#FFF", color: "" }}>
        <Mensaje
          mensaje={mensaje}
          onHide={() => {
            mensaje.titulo === "Exito."
              ? cerrarModal()
              : setMensaje({
                  mostrar: false,
                  titulo: "",
                  texto: "",
                  icono: "",
                });
          }}
        />
        <MensajeSiNo
          mensaje={mensajesino}
          onHideNo={() =>
            setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
          }
          onHideSi={handleCloseSi}
        />
        <Dimmer active={activate} />
        <div
          className=""
          style={{ height: "auto", maxHeight: "72vh", overflow: "auto" }}
        >
          <div>
            <div className="row rounded mx-auto">
              <div className="border-azul rounded">
                <div className="card-body">
                  <div className="col-md-12 row py-2">
                    <div className="input-group input-group-sm col-sm-6">
                      <label className="fw-bold" id="inputGroup-sizing-sm">
                        Monto Total del Documento:
                      </label>
                      <p className="px-2 m-1">
                        {formatMoneda(
                          props.totalfactura.replace(",", "").replace(".", ","),
                          ",",
                          ".",
                          2
                        )}
                      </p>
                    </div>

                    <div className="input-group input-group-sm col-sm-5 ml-auto px-4">
                      <label
                        className="input-group-text fs-title"
                        id="inputGroup-sizing-sm"
                      >
                        Fecha del Documento:
                      </label>
                      <input
                        type="date"
                        ref={txtFechaDoc}
                        className="form-control"
                        name="fecha"
                        id="fechaDoc"
                        defaultValue={
                          props.fecha
                            ? props.fecha !== null
                              ? moment(props.fecha).format("YYYY-MM-DD")
                              : ""
                            : moment(fechaSistema).format("YYYY-MM-DD")
                        }
                        aria-label="Sizing example input"
                        aria-describedby="inputGroup-sizing-sm"
                        onKeyUp={handleInputChange}
                        onBlur={handleInputChange}
                      />
                    </div>
                  </div>

                  <div className="border-azul rounded py-2 mx-0">
                    <div className="col-md-12 row py-2">
                      <div className="input-group input-group-sm col-md-6">
                        <label
                          className="input-group-text fs-title"
                          id="inputGroup-sizing-sm"
                        >
                          Forma de Pago:
                        </label>
                        <select
                          ref={cmbFormaPago}
                          className="form-select form-select-sm"
                          aria-label=".form-select-sm example"
                          defaultValue={3}
                        >
                          {/* <option value="0" selected>Seleccione</option> */}
                          <option value="1">CHEQUE</option>
                          <option value="2">TARJETA DE DEBITO</option>
                          <option value="3">TRANSFERENCIA</option>
                          <option value="4">DEPOSITO</option>
                          <option value="5">TARJETA DE CREDITO</option>
                        </select>
                      </div>

                      <div className="input-group input-group-sm col-md-6">
                        <label
                          className="input-group-text fs-title"
                          id="inputGroup-sizing-sm"
                        >
                          Banco:
                        </label>
                        <select
                          onChange={handleChangeBancoCli}
                          ref={cmbBancoCli}
                          name="bancoCli1"
                          className="form-control"
                        >
                          <option value={0}>--Seleccione--</option>
                          {bancos &&
                            bancos.map((bancos) => (
                              <option
                                key={bancos.idbanco + "B1"}
                                value={bancos.idbanco}
                              >
                                {bancos.nombre}
                              </option>
                            ))}
                        </select>
                      </div>
                    </div>
                    <div className="col-md-12 row py-2">
                      <div className="input-group input-group-sm col-md-6">
                        <label
                          className="input-group-text fs-title"
                          id="inputGroup-sizing-sm"
                        >
                          N° de Documento:
                        </label>
                        <input
                          type="text"
                          ref={txtReferencia}
                          className="form-control"
                          aria-describedby="validationTooltipMinimo"
                          maxLength="25"
                          name="numdocumento"
                          id="numdocumento"
                          placeholder="Ingrese el Número de Documento"
                          required
                        />
                      </div>

                      <div className="input-group input-group-sm col-md-4 ml-auto">
                        <label
                          className="input-group-text fs-title"
                          id="inputGroup-sizing-sm"
                        >
                          Monto:
                        </label>
                        <input
                          type="text"
                          ref={txtMonto}
                          className="form-control text-right"
                          aria-label="Sizing example input"
                          aria-describedby="inputGroup-sizing-sm"
                          id="inputMonto"
                          defaultValue={"0,00"}
                          onFocus={seleccionarCampo}
                          onBlur={handleInputMontoChange}
                          onKeyUp={handleInputMontoChange}
                          placeholder="0,00"
                        />
                      </div>
                    </div>
                    <div className="col-md-12 row py-2">
                      <div className="input-group input-group-sm col-md-12">
                        <label
                          className="input-group-text fs-title"
                          id="inputGroup-sizing-sm"
                        >
                          Datos de la Cuenta Bancaria a Depositar:
                        </label>
                        <select
                          ref={cmbCuenta}
                          onChange={handleChangeCuentaBan}
                          className="form-control"
                        >
                          <option value={0}>--Seleccione--</option>
                          {cuentas &&
                            cuentas.map((bancos) => (
                              <option
                                key={bancos.cuentabancaria}
                                value={bancos.idcuentabancaria}
                              >
                                {" "}
                                {bancos.nombre + " -- " + bancos.cuentabancaria}
                              </option>
                            ))}
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          ref={btnAcepta}
          onClick={onChangeValidar}
          className="btn btn-sm rounded-pill btn-success col-md-2"
        >
          <i className="fas fa-check-circle"> Aceptar</i>
        </button>
        <button
          ref={btnCancela}
          onClick={cancelar}
          className="btn btn-danger btn-sm rounded-pill col-md-2"
        >
          <i className="fas fa-window-close"> Cancelar</i>
        </button>
      </Modal.Footer>
    </Modal>
  );
};



// WEBPACK FOOTER //
// ./src/components/modalFormadePago.js